const FILTER_SELECTOR: string = "[data-filter-control-for]";
const HIGHLIGHT_SELECTOR: string = "#control--highlight";
import { wrapGrid } from 'animate-css-grid';

export class filterUI {
  private filterControlName: string = this.base.getAttribute("data-filter-control-for");
  private filterControlItems: NodeListOf<HTMLElement> = document.querySelectorAll(`[data-filter-control=${this.filterControlName}] .customer__list__item`);
  private filterLinks = this.base.querySelectorAll('a');

  public constructor(private base: HTMLElement) {
    const grid: HTMLElement = document.querySelector(`[data-filter-control=${this.filterControlName}]`);
    wrapGrid(grid, {
      // int: default is 0 ms
      stagger: 0,
      // int: default is 250 ms
      duration: 500,
      // string: default is 'easeInOut'
      easing: 'easeInOut',
      // function: called with list of elements about to animate
      onStart: (animatingElementList) => { },
      // function: called with list of elements that just finished animating
      // cancelled animations will not trigger onEnd
      onEnd: (animatingElementList) => { }
    });
  }

  public onFilterClick(callback: (filterGroupName: string) => void) {
    const filter = Array.from(this.filterLinks);
    filter.map((item: HTMLElement) => {
      item.addEventListener('click', () => {
        const name = item.getAttribute('data-filter')
        this.setActive(item);
        callback(name);
      });
    });
  }

  public filterByCategoryName(name: string) {
    const filterControlItemsArray : HTMLElement[] = Array.from(this.filterControlItems);
    filterControlItemsArray.map((el) => {
      const categoryName = el.getAttribute('data-filter-group');
      if (name === "all") {
        this.showItem(el);
        return ;
      } else if (name === categoryName) {
        this.showItem(el)
      } else {
        this.hideItem(el);
      }
    });
  }

  private setActive(el: HTMLElement) {
    const filter = Array.from(this.filterLinks);
    filter.map(el => {
      el.classList.remove('is-active')
    });

    const filterHighlight =  this.base.querySelector(HIGHLIGHT_SELECTOR) as HTMLElement;
    const itemWidth = el.clientWidth;
    const itemOffsetLeft = el.offsetLeft
    el.classList.add('is-active');

   filterHighlight.style.width = `${itemWidth}px`;
   filterHighlight.style.transform = `translateX(${itemOffsetLeft}px)`;
  }

  private hideItem(el: HTMLElement) {
    el.parentElement.classList.add('is-hidden');
  }

  private showItem(el: HTMLElement) {
    el.parentElement.classList.remove('is-hidden');
  }
}

export function createFilterUI() {
  const $base = document.querySelectorAll(FILTER_SELECTOR);
  let uiInstances: filterUI[] = [];

  for (let index = 0; index < $base.length; index++) {
    const element = $base[index] as HTMLElement;
    uiInstances.push(new filterUI(element));
  }
  return uiInstances;
}
